//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/check_box'
import 'devextreme/ui/date_box'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/number_box'
import 'devextreme/ui/popup'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/select_box'
import 'devextreme/ui/toolbar'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { ScheduleController } from './schedule.controller'
import { IUserSession } from '../../../helpers'

//#region Asset Imports

import './schedule.scss'
import * as TEMPLATE from './schedule.tpl.html'

//#endregion

export class ScheduleDirective implements ng.IDirective {

    restrict = 'E'
    scope = {
        profilesList: '=',
        idConfigurationProfile: '='
    }
    template = TEMPLATE

    controller = ['$scope', '$q', '$timeout', 'api', 'logger', 'localDictionary', 'userSession', ($scope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, userSession: IUserSession) => new ScheduleController($scope, $q, $timeout, api, localDictionary, userSession)]

    transclude = true
}